import React, { PureComponent } from "react";
import { connect } from "react-redux";

import {
  setCurrentNavPage,
  setBalanceSheetOrganization,
  setAttachmentFileLink
} from "Actions";
import { fetchDashboard, fetchComments, fetchFicheClient } from "Thunks";
import styles from "./Dashboard.local.scss";
import Dashboard from "./Dashboard";
import NotFoundV2 from "../NotFound/NotFoundV2";
import { push } from "react-router-redux";
import _ from "i18n";
import AnnexeIframe from "../Common/iframes/AnnexeIframe";
import { getTemporaryAnnexeFileLink } from "Utils";
import browserHistory from "history/createBrowserHistory";
import HeaderFicheClient from "../FicheClient/HeaderFicheClient";

class DashboardPage extends PureComponent {
  constructor(props) {
    super(props);
    let { uen, year } = this.props.match.params;
    this.state = {
      year: year,
      organizationUen: uen,
      hideIframe: true,
      loadingIframe: true,
      isNotFound: false
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { organizationUen, year } = this.state;
    // let defaultYear = browserHistory().location.search;
    // let year =
    //   defaultYear && defaultYear.includes("year")
    //     ? defaultYear.replace("?year=", "").slice(0, 4)
    //     : null;
    dispatch(setCurrentNavPage("DASHBOARD_PAGE"));
    dispatch(fetchComments(organizationUen, year));
    dispatch(fetchDashboard(year, organizationUen, organizationUen, null));
    this.handleChangeYear(year);
  }

  handleOnClickUpdate = id => {
    let { dispatch } = this.props;
    dispatch(push(`/composition/dashboard/${id}`));
  };

  handleOnClickSwitchToBalanceSheet = () => {
    let { dispatch, organization } = this.props;
    const { organizationUen } = this.state;
    dispatch(setBalanceSheetOrganization(organization));
    dispatch(push("/balance-sheet/" + organizationUen));
  };

  handleError = () => {
    const { error } = this.props;

    if (error.code === 170043) {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={"noBalanceImportedMessage"}
        />
      );
    } else if (error.code === 170060) {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={`${_("accessDenied")} : ${_("dashboardNotFound")}`}
        />
      );
    } else {
      return (
        <NotFoundV2 errorPageType={"ACCESS_DENIED"} text={"errorOccured"} />
      );
    }
  };

  handleOnClickDiaporama = () => {
    let { dispatch } = this.props;
    const { organizationUen } = this.state;

    let year = browserHistory().location.search;
    year && year.includes("year")
      ? dispatch(
          push(
            `/diaporama/${organizationUen}?year=${year
              .replace("?year=", "")
              .slice(0, 4)}`
          )
        )
      : dispatch(push(`/diaporama/${organizationUen}`));
  };

  handleOnClickPrepare = () => {
    let { dispatch } = this.props;
    const { organizationUen } = this.state;
    let year = browserHistory().location.search;
    year && year.includes("year")
      ? dispatch(
          push(
            `/prepare-presentation/${organizationUen}?year=${year
              .replace("?year=", "")
              .slice(0, 4)}`
          )
        )
      : dispatch(push(`/prepare-presentation/${organizationUen}`));
  };

  handleYearChange = value => {
    const { dispatch } = this.props;
    dispatch(push("?year=" + value));
  };

  displayAnnexePDF = annexeCategory => {
    const { annexeAttachments, token } = this.props;
    this.setState({
      hideIframe: false,
      loadingIframe: true,
      isNotFound: false
    });
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.remove("hide");
    document.body.classList.add("hidden_overflow");

    let annexe = annexeAttachments.filter(
      ({ category }) => category.id === annexeCategory
    );

    if (annexe[0]) {
      this.props.dispatch(
        setAttachmentFileLink(
          getTemporaryAnnexeFileLink(annexe[0].id, annexe[0].filePath, token)
        )
      );
      setTimeout(() => {
        this.setState({ loadingIframe: false });
      }, 2000);
    } else {
      setTimeout(() => {
        this.setState({ loadingIframe: false, isNotFound: true });
      }, 2000);
    }
  };

  closeAnnexePDF = () => {
    this.setState({ hideIframe: true });
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
    document.body.classList.remove("hidden_overflow");

    this.props.dispatch(setAttachmentFileLink(""));
  };

  handleChangeYear = value => {
    const { dispatch, synchro } = this.props;
    const { organizationUen } = this.state;
    this.setState({
      year: value
    });
    dispatch(fetchFicheClient(organizationUen, synchro, value));
    dispatch(fetchDashboard(value, organizationUen, organizationUen, null));
  };

  handleGetYears = () => {
    const { years } = this.props;
    if (years) {
      return years;
    } else {
      return [];
    }
  };

  componentWillUnmount(): void {
    this.closeAnnexePDF();
  }

  render() {
    const {
      dashboardData,
      organization,
      currentOrganization,
      fetching,
      fetched,
      error,
      attachmentFileLink,
      commentFetched,
      commentFetching
    } = this.props;

    let { hideIframe, loadingIframe, isNotFound, year } = this.state;
    let years = this.handleGetYears();
    return (
      <div
        className={`page-content`}
        style={{
          backgroundColor: `#FAFBFB`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          minHeight: 800
        }}
      >
        <HeaderFicheClient
          currentPage="DASHBOARD"
          handleOnClickPrepare={this.handleOnClickPrepare}
          handleOnClickDiaporama={this.handleOnClickDiaporama}
          organization={organization}
          uen={this.state.organizationUen}
          selectedYear={year}
          years={years}
          handleChangeYear={value => this.handleChangeYear(value)}
        />
        {(fetching || commentFetching) && (
          <div className={styles.ripple_loading}>
            <img src={"/img/Ripple-1s-150px.svg"} alt="" />
          </div>
        )}

        {/* @todo gérer les cas de not found*/}
        {error && !fetching && this.handleError()}

        {fetched &&
          dashboardData &&
          commentFetched && (
            <Dashboard
              data={dashboardData}
              organization={organization}
              currentOrganization={currentOrganization}
              handleOnClickUpdate={this.handleOnClickUpdate}
              handleOnClickDiaporama={this.handleOnClickDiaporama}
              handleOnClickSwitchToBalanceSheet={
                this.handleOnClickSwitchToBalanceSheet
              }
              handleDisplayAnnexePDF={this.displayAnnexePDF}
              handleOnClickPrepare={this.handleOnClickPrepare}
              handleYearChange={this.handleYearChange}
            />
          )}
        <AnnexeIframe
          hideIframe={hideIframe}
          srcIframe={attachmentFileLink}
          loadingIframe={loadingIframe}
          onCloseIframe={this.closeAnnexePDF}
          isNotFound={isNotFound}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.dashboard.fetching,
  fetched: state.dashboard.fetched,
  error: state.dashboard.error,
  dashboardData: state.dashboard.data,
  organization: state.dashboard.organization,
  attachmentFileLink: state.dashboard.attachmentFileLink,
  currentOrganization: state.auth.currentOrganization,
  annexeAttachments: state.dashboard.data.annexeAttachments,
  token: state.auth.token,
  commentFetching: state.preparePresentation.fetching,
  commentFetched: state.preparePresentation.fetched,
  years:
    state.dashboard.data.extraInfos && state.dashboard.data.extraInfos.years,
  synchro: state.fiduciary.data && state.fiduciary.data.synchro
});

export default connect(mapStateToProps)(DashboardPage);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardPage.js